module.exports = __webpack_public_path__ + "img/tron (9).9bc99192.jpg";